module.exports = __webpack_public_path__ + "img/LGGJLequipe.94a17e1b.jpg";